module.exports = "/img/17.81c211.webp";